<template>
  <div class="view-507">
    <view322 />
    <div class="view-508">
      <div class="x25-46 poppins-normal-storm-dust-14px">10 модулей</div>
      <img
        class="vector-312"
        src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/vector-193.svg"
        alt="Vector"
      />
    </div>
    <view332 />
  </div>
</template>

<script>
import View322 from "./View322";
import View332 from "./View332";
export default {
  name: "View49",
  components: {
    View322,
    View332,
  },
};
</script>

<style>
.view-507,
.view-509 {
  display: flex;
  gap: 28px;
  height: 25px;
  left: 91px;
  position: absolute;
  top: 400px;
  width: 363px;
}

.view-508,
.view-510 {
  height: 25px;
  position: relative;
  width: 112.22px;
}

.x25-46,
.x25-47 {
  left: 31px;
  letter-spacing: 0.28px;
  line-height: 25.2px;
  position: absolute;
  top: 0;
  white-space: nowrap;
}

.vector-312,
.vector-313 {
  height: 96.88%;
  left: 0;
  position: absolute;
  top: 0;
  width: 21.58%;
}
</style>
